import { Box, Flex, Image } from "@chakra-ui/react";
import React from "react";
import styles from "../../styles/heading.module.css";
import image from "../../images/portfolioImage.jpg";

const NameImg = () => {
  return (
    <Box id="Home" pt={{ lg: "70px", md: "65px", sm: "0px" }}>
      <Flex h="400px" flexDir={{ lg: "row", md: "row", sm: "column-reverse" }}>
        <Flex
          flexDir="column"
          align="center"
          justify="center"
          w={{ lg: "50%", md: "50%", sm: "100%" }}
          textAlign={"center"}
        >
          <h1 className={styles.head}>Hi, I am Faizal Siddiqui</h1>
          <h1 className={styles.head}>Full Stack Web Developer</h1>
        </Flex>
        <Flex
          w={{ lg: "50%", md: "50%", sm: "100%" }}
          align="center"
          justify="center"
        >
          <Box
            mt={{ sm: "10px" }}
            bgColor="#fff"
            overflow="hidden"
            w={{ lg: "300px", md: "250px", sm: "200px" }}
            h={{ lg: "300px", md: "250px", sm: "200px" }}
            borderRadius="50%"
          >
            <Image draggable={false} src={image} alt="profile-pic" />
          </Box>
        </Flex>
      </Flex>
    </Box>
  );
};

export default NameImg;
